/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winteroccpressuresetpoint3Inputs */



/**
* | output |
* | --- |
* | "Winter occupied pressure setpoint" |
*
* @param {Ahu_History_Key_Winteroccpressuresetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winteroccpressuresetpoint3 = /** @type {((inputs?: Ahu_History_Key_Winteroccpressuresetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winteroccpressuresetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter occupied pressure setpoint")
	return /** @type {LocalizedString} */ ("Consigne de pression occupation hiver")
});
export { ahu_history_key_winteroccpressuresetpoint3 as "ahu_history_key_winterOccPressureSetpoint" }